// Empowered Cooks homepage behaviors: YouTube-only strip and click-to-load videos.

if (!customElements.get('ec-youtube-strip')) {
  customElements.define(
    'ec-youtube-strip',
    class EcYoutubeStrip extends HTMLElement {
      connectedCallback() {
        const key = 'ec-yt-strip-dismissed';
        let dismissed = false;
        try {
          dismissed = window.localStorage.getItem(key) === '1';
        } catch (e) {}
        if (dismissed || !this.isFromYoutube()) return;

        this.hidden = false;
        const close = this.querySelector('[data-ec-dismiss]');
        if (close) {
          close.addEventListener('click', () => {
            this.hidden = true;
            try {
              window.localStorage.setItem(key, '1');
            } catch (e) {}
          });
        }
      }

      isFromYoutube() {
        if (this.dataset.preview === 'true') return true;
        const params = new URLSearchParams(window.location.search);
        const source = (params.get('utm_source') || '').toLowerCase();
        if (source === 'youtube') return true;
        return /(^|\.)youtube\.com|youtu\.be/.test(document.referrer || '');
      }
    }
  );
}

if (!customElements.get('ec-sticky-cta')) {
  customElements.define(
    'ec-sticky-cta',
    class EcStickyCta extends HTMLElement {
      connectedCallback() {
        const target = this.closest('section')?.querySelector('[data-ec-hero-cta]');
        if (!target) return;
        // Scroll-based so a fast jump past the hero buttons still shows the bar.
        const update = () => {
          this.hidden = target.getBoundingClientRect().bottom > 0;
        };
        window.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
        update();
      }
    }
  );
}

if (!customElements.get('ec-video')) {
  customElements.define(
    'ec-video',
    class EcVideo extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => {
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${this.dataset.id}?autoplay=1&rel=0`;
          iframe.title = this.dataset.title || 'YouTube video';
          iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          button.replaceWith(iframe);
        });
      }
    }
  );
}
